<template>
 <section id="subPage">
	<div class="container">
		<div class="row">
			<div class="col-md-4">
				<MenuPanelim></MenuPanelim>
			</div>
            <div class="col-md-8 cont contProfil" ref="formContainer">
    <nav class="navbar navbar-expand-lg navbar-light">
        <a class="navbar-brand" href="#" style="text-decoration: none;pointer-events: none;">Hesabım</a>
        <div class="collapse navbar-collapse" id="navbarNav">
            <ul class="navbar-nav">
                <li class="nav-item active"><router-link to="/" class="nav-link">Ana Sayfa <span class="sr-only">(current)</span></router-link></li>
                <!-- <li class="nav-item"><a class="nav-link" href="#">Örnek</a></li> -->
                <li class="nav-item"><a class="nav-link disabled" href="#" tabindex="-1" aria-disabled="true">Profilim</a></li>
            </ul>
        </div>
    </nav>
    <form @submit.prevent="handleSubmit">
        <div class="row">
            <div class="col-md-12">
                <h3>Kişisel Bilgiler</h3>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="form-row">
                    <div class="form-group col-md-6">
                        <label for="ad">AD*</label>
                        <input type="text" v-model="user.ad" class="form-control" id="ad" name="ad" :class="{ 'is-invalid': submitted && $v.user.ad.$error }" disabled>
                        <div v-if="submitted && !$v.user.ad.required" class="invalid-feedback">Adınızı giriniz</div>
                    </div>
                    <div class="form-group col-md-6">
                        <label for="soyad">SOYAD*</label>
                        <input type="text" v-model="user.soyad" class="form-control" id="soyad" name="soyad" :class="{ 'is-invalid': submitted && $v.user.soyad.$error }" disabled>
                        <div v-if="submitted && !$v.user.soyad.required" class="invalid-feedback">Soyadınızı giriniz</div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6">
                        <label for="dogum">DOĞUM TARİHİ*</label>
                        <input type="text" v-mask="'##.##.####'" v-model="user.dogumTarihi" class="form-control tarih" id="dogumTarihi" name="dogumTarihi" :class="{ 'is-invalid': submitted && $v.user.dogumTarihi.$error }" disabled>
                        <div v-if="submitted && !$v.user.dogumTarihi.required" class="invalid-feedback">Doğum tarihinizi giriniz</div>
                    </div>
                    <div class="form-group col-md-2">
                        <label for="kimlik_secimi">KİMLİK TİPİ</label>
                        <select v-model="user.kimlik_tipi" id="kimlik_tipi" class="form-control identity" :class="{ 'is-invalid': submitted && $v.user.kimlik_tipi.$error }" disabled>
                            <option value="0">T.C. Kimlik</option>
                            <option value="1">Pasaport</option>
                        </select>
                        <div v-if="submitted && !$v.user.kimlik_tipi.required" class="invalid-feedback">Kimlik tipini seçiniz</div>
                    </div>
                    <div class="form-group col-md-4">
                        <label for="kimlik_tc">KİMLİK NO</label>
                        <input type="tel" class="form-control" id="kimlik_no" v-model="user.kimlik_no" :class="{ 'is-invalid': submitted && $v.user.kimlik_no.$error }" disabled>
                        <div v-if="submitted && !$v.user.kimlik_no.required" class="invalid-feedback">Kimlik numaranızı giriniz</div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-4">
                        <label for="ehliyet_alis_yeri">EHLİYET ALIŞ YERİ*</label>
                        <input type="text" v-model="user.ehliyet_alis_yeri" class="form-control" id="ehliyet_alis_yeri" name="ehliyet_alis_yeri" :class="{ 'is-invalid': submitted && $v.user.ehliyet_alis_yeri.$error }">
                        <div v-if="submitted && !$v.user.ehliyet_alis_yeri.required" class="invalid-feedback">Ehliyet numaranızı giriniz</div>
                    </div>
                    <div class="form-group col-md-4">
                        <label for="ehliyet_no">EHLİYET NUMARASI*</label>
                        <input type="text" v-model="user.ehliyet_no" class="form-control" id="ehliyet_no" name="ehliyet_no" :class="{ 'is-invalid': submitted && $v.user.ehliyet_no.$error }">
                        <div v-if="submitted && !$v.user.ehliyet_no.required" class="invalid-feedback">Ehliyet numaranızı giriniz</div>
                    </div>
                    <div class="form-group col-md-4">
                        <label for="ehliyet_tarih">EHLİYET ALIŞ TARİHİ</label>
                        <input type="text" v-mask="'##.##.####'" v-model="user.ehliyet_tarih" class="form-control tarih" id="ehliyet_tarih" name="ehliyet_tarih" :class="{ 'is-invalid': submitted && $v.user.ehliyet_tarih.$error }" >
                        <div v-if="submitted && !$v.user.ehliyet_tarih.required" class="invalid-feedback">Ehliyet alış tarihini giriniz</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <h3>İletişim Bilgileri</h3>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="form-row">
                    <div class="form-group col-md-6">
                        <label for="eposta">E-POSTA ADRESİ <small>(Kullanıcı Adı)</small>*</label>
                        <input type="email" v-model="user.eposta" class="form-control" id="eposta" name="eposta" :class="{ 'is-invalid': submitted && $v.user.eposta.$error }">
                        <div v-if="submitted && $v.user.eposta.$error" class="invalid-feedback">
                            <span v-if="!$v.user.eposta.required">E-posta adresinizi giriniz</span>
                            <span v-if="!$v.user.eposta.email">Geçerli bir e-posta adresi giriniz</span>
                        </div>
                    </div>
                    <div class="form-group col-md-6">
                        <label for="gsm">GSM NUMARASI*</label>
                        <!-- <input type="tel" v-model="user.gsm" class="form-control" id="gsm" name="gsm" :class="{ 'is-invalid': submitted && $v.user.gsm.$error }"> -->
                        <vue-tel-input type="tel" v-model="user.gsm" id="gsm" name="gsm" placeholder="Telefon numaranız" mode='international' :required=true></vue-tel-input>
                        <div v-if="submitted && !$v.user.gsm.required" class="invalid-feedback">Telefon numaranızı giriniz</div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6">
                        <label for="ulke">ÜLKE*</label>
                        <select name="ulke" v-model="user.ulke" id="ulke" class="form-control" :class="{ 'is-invalid': submitted && $v.user.ulke.$error }">
                        <option value="">Seçiniz</option>
                        <option :value="user.ulke">{{user.ulke}}</option>
                        <option value="A.B.D.">A.B.D.</option>
                                <option value="AFGANİSTAN">AFGANİSTAN </option>
                                <option value="ALAND ADALARI">ALAND ADALARI </option>
                                <option value="ALMANYA">ALMANYA </option>
                                <option value="AMERİKAN SAMUA">AMERİKAN SAMUA </option>
                                <option value="ANDORRA">ANDORRA </option>
                                <option value="ANGOLA">ANGOLA </option>
                                <option value="ANGUILLA">ANGUILLA </option>
                                <option value="ANTARTİKA">ANTARTİKA </option>
                                <option value="ANTIGUA VE BARBUDA">ANTIGUA VE BARBUDA </option>
                                <option value="ARJANTİN">ARJANTİN </option>
                                <option value="ARNAVUTLUK">ARNAVUTLUK </option>
                                <option value="ARUBA">ARUBA </option>
                                <option value="AVUSTRALYA">AVUSTRALYA </option>
                                <option value="AVUSTURYA">AVUSTURYA </option>
                                <option value="AZERBAYCAN">AZERBAYCAN </option>
                                <option value="BAHAMALAR">BAHAMALAR </option>
                                <option value="BAHREYN">BAHREYN </option>
                                <option value="BANGLADEŞ">BANGLADEŞ </option>
                                <option value="BARBADOS">BARBADOS </option>
                                <option value="BELARUS">BELARUS </option>
                                <option value="BELÇİKA">BELÇİKA </option>
                                <option value="BELİZE">BELİZE </option>
                                <option value="BENELÜKS">BENELÜKS </option>
                                <option value="BENIN">BENIN </option>
                                <option value="BERMUDA">BERMUDA </option>
                                <option value="BHUTAN">BHUTAN </option>
                                <option value="BİRLEŞİK ARAP EMİRLİKLERİ">BİRLEŞİK ARAP EMİRLİKLERİ </option>
                                <option value="BOLIVIA">BOLIVIA </option>
                                <option value="BOSNA HERSEK">BOSNA HERSEK </option>
                                <option value="BOTSWANA">BOTSWANA </option>
                                <option value="BOUVET ADASI">BOUVET ADASI </option>
                                <option value="BREZİLYA">BREZİLYA </option>
                                <option value="BRUNEI DARUSSALAM">BRUNEI DARUSSALAM </option>
                                <option value="BULGARİSTAN">BULGARİSTAN </option>
                                <option value="BURKINA FASO">BURKINA FASO </option>
                                <option value="BURUNDI">BURUNDI </option>
                                <option value="CEZAYİR">CEZAYİR </option>
                                <option value="COCOS ADALARI">COCOS ADALARI </option>
                                <option value="COSTA RICA">COSTA RICA </option>
                                <option value="ÇEK CUMHURİYETİ">ÇEK CUMHURİYETİ </option>
                                <option value="ÇİN">ÇİN </option>
                                <option value="DANİMARKA">DANİMARKA </option>
                                <option value="DİĞER">DİĞER </option>
                                <option value="DOĞU TİMOR">DOĞU TİMOR </option>
                                <option value="DOMİNİK CUMHURİYETİ">DOMİNİK CUMHURİYETİ </option>
                                <option value="EKVATOR">EKVATOR </option>
                                <option value="EL SALVADOR">EL SALVADOR </option>
                                <option value="ENDONEZYA">ENDONEZYA </option>
                                <option value="ERMENİSTAN">ERMENİSTAN </option>
                                <option value="ESTONYA">ESTONYA </option>
                                <option value="ETİYOPYA">ETİYOPYA </option>
                                <option value="FALKLAND ADALARI">FALKLAND ADALARI </option>
                                <option value="FAS">FAS </option>
                                <option value="FİJİ">FİJİ </option>
                                <option value="FİLİPİNLER">FİLİPİNLER </option>
                                <option value="FİLİSTİN">FİLİSTİN </option>
                                <option value="FİNLANDİYA">FİNLANDİYA </option>
                                <option value="FRANSA">FRANSA </option>
                                <option value="GAMBİA">GAMBİA </option>
                                <option value="GANA">GANA </option>
                                <option value="GİNE">GİNE </option>
                                <option value="GUATEMALA">GUATEMALA </option>
                                <option value="GÜNEY AFRİKA">GÜNEY AFRİKA </option>
                                <option value="GÜRCİSTAN">GÜRCİSTAN </option>
                                <option value="HAİTİ">HAİTİ </option>
                                <option value="HİNDİSTAN">HİNDİSTAN </option>
                                <option value="HIRVATİSTAN">HIRVATİSTAN </option>
                                <option value="HOLLANDA">HOLLANDA </option>
                                <option value="HOLLANDA ANTILLER">HOLLANDA ANTILLER </option>
                                <option value="HONDURAS">HONDURAS </option>
                                <option value="İNGİLTERE">İNGİLTERE </option>
                                <option value="IRAK">IRAK </option>
                                <option value="İRAN">İRAN </option>
                                <option value="İRLANDA">İRLANDA </option>
                                <option value="İSPANYA">İSPANYA </option>
                                <option value="İSRAİL">İSRAİL </option>
                                <option value="İSVEÇ">İSVEÇ </option>
                                <option value="İSVİÇRE">İSVİÇRE </option>
                                <option value="İTALYA">İTALYA </option>
                                <option value="İZLANDA">İZLANDA </option>
                                <option value="JAMAICA">JAMAICA </option>
                                <option value="JAPONYA">JAPONYA </option>
                                <option value="KAMBOÇYA">KAMBOÇYA </option>
                                <option value="KANADA">KANADA </option>
                                <option value="KATAR">KATAR </option>
                                <option value="KAZAKİSTAN">KAZAKİSTAN </option>
                                <option value="KENYA">KENYA </option>
                                <option value="KIRGIZİSTAN">KIRGIZİSTAN </option>
                                <option value="KİRİBATİ">KİRİBATİ </option>
                                <option value="KOLOMBİYA">KOLOMBİYA </option>
                                <option value="KONGO">KONGO </option>
                                <option value="KORE">KORE </option>
                                <option value="KUVEYT">KUVEYT </option>
                                <option value="KÜBA">KÜBA </option>
                                <option value="LAOS">LAOS </option>
                                <option value="LATVİYA">LATVİYA </option>
                                <option value="LİBYA">LİBYA </option>
                                <option value="LIECHTENSTEIN">LIECHTENSTEIN </option>
                                <option value="LİTVANYA">LİTVANYA </option>
                                <option value="LÜBNAN">LÜBNAN </option>
                                <option value="LÜKSEMBURG">LÜKSEMBURG </option>
                                <option value="MACARİSTAN">MACARİSTAN </option>
                                <option value="MADAGASKAR">MADAGASKAR </option>
                                <option value="MAKEDONYA">MAKEDONYA </option>
                                <option value="MALDİVLER">MALDİVLER </option>
                                <option value="MALEZYA">MALEZYA </option>
                                <option value="MALİ">MALİ </option>
                                <option value="MALTA">MALTA </option>
                                <option value="MEKSİKA">MEKSİKA </option>
                                <option value="MISIR">MISIR </option>
                                <option value="MOĞOLİSTAN">MOĞOLİSTAN </option>
                                <option value="MOLDOVA">MOLDOVA </option>
                                <option value="MONACO">MONACO </option>
                                <option value="MOZAMBİK">MOZAMBİK </option>
                                <option value="NAMİBİA">NAMİBİA </option>
                                <option value="NEPAL">NEPAL </option>
                                <option value="NİJERYA">NİJERYA </option>
                                <option value="NİKARAGUA">NİKARAGUA </option>
                                <option value="NORFOLK ADASI">NORFOLK ADASI </option>
                                <option value="NORVEÇ">NORVEÇ </option>
                                <option value="ÖZBEKİSTAN">ÖZBEKİSTAN </option>
                                <option value="PAKİSTAN">PAKİSTAN </option>
                                <option value="PANAMA">PANAMA </option>
                                <option value="PAPUA YENİ GİNE">PAPUA YENİ GİNE </option>
                                <option value="PARAGUAY">PARAGUAY </option>
                                <option value="PERU">PERU </option>
                                <option value="POLONYA">POLONYA </option>
                                <option value="PORTEKİZ">PORTEKİZ </option>
                                <option value="PORTO RİKO">PORTO RİKO </option>
                                <option value="ROMANYA">ROMANYA </option>
                                <option value="RUANDA">RUANDA </option>
                                <option value="RUSYA">RUSYA </option>
                                <option value="SAN MARINO">SAN MARINO </option>
                                <option value="SENEGAL">SENEGAL </option>
                                <option value="SEYŞELLER">SEYŞELLER </option>
                                <option value="SİNGAPUR">SİNGAPUR </option>
                                <option value="SIRBİSTAN">SIRBİSTAN </option>
                                <option value="SLOVAKYA">SLOVAKYA </option>
                                <option value="SLOVENYA">SLOVENYA </option>
                                <option value="SOLOMON ADALARI">SOLOMON ADALARI </option>
                                <option value="SOMALİ">SOMALİ </option>
                                <option value="SRİ LANKA">SRİ LANKA </option>
                                <option value="SUDAN">SUDAN </option>
                                <option value="SURİYE">SURİYE </option>
                                <option value="SUUDİ ARABİSTAN">SUUDİ ARABİSTAN </option>
                                <option value="ŞİLİ">ŞİLİ </option>
                                <option value="TACİKİSTAN">TACİKİSTAN </option>
                                <option value="TANZANYA">TANZANYA </option>
                                <option value="TAYLAND">TAYLAND </option>
                                <option value="TAYVAN">TAYVAN </option>
                                <option value="TOGO">TOGO </option>
                                <option value="TONGA">TONGA </option>
                                <option value="TRİNİDAD VE TOBAGO">TRİNİDAD VE TOBAGO </option>
                                <option value="TUNUS">TUNUS </option>
                                <option value="TUVALU">TUVALU </option>
                                <option value="TÜRKMENİSTAN">TÜRKMENİSTAN </option>
                                <option value="UGANDA">UGANDA </option>
                                <option value="UKRAYNA">UKRAYNA </option>
                                <option value="URUGUAY">URUGUAY </option>
                                <option value="ÜRDÜN">ÜRDÜN </option>
                                <option value="VATİKAN">VATİKAN </option>
                                <option value="VENEZUELA">VENEZUELA </option>
                                <option value="VİETNAM">VİETNAM </option>
                                <option value="YEMEN">YEMEN </option>
                                <option value="YENİ ZELANDA">YENİ ZELANDA </option>
                                <option value="YUNANİSTAN">YUNANİSTAN </option>
                                <option value="ZAMBİA">ZAMBİA </option>
                                <option value="ZİMBABWE">ZİMBABWE </option>
                                <option value="KIBRIS">KIBRIS </option>
                        </select>
                        <div v-if="submitted && !$v.user.ulke.required" class="invalid-feedback">Ülkenizi seçiniz</div>
                    </div>
                    <div class="form-group col-md-6">
                        <label for="sehir">ŞEHİR*</label>
                        <select name="sehir" v-model="user.sehir" id="sehir" class="form-control" :class="{ 'is-invalid': submitted && $v.user.sehir.$error }">
                        <option value="sdsdf">Seçiniz</option>
                        <option :value="user.sehir">{{user.sehir}}</option>
                        <option value="ADIYAMAN">ADIYAMAN </option>
                                    <option value="AKSARAY">AKSARAY </option>
                                    <option value="ARDAHAN">ARDAHAN </option>
                                    <option value="AFYON">AFYON </option>
                                    <option value="AĞRI">AĞRI </option>
                                    <option value="AMASYA">AMASYA </option>
                                    <option value="ANKARA">ANKARA </option>
                                    <option value="ANTALYA">ANTALYA </option>
                                    <option value="ARTVİN">ARTVİN </option>
                                    <option value="AYDIN">AYDIN </option>
                                    <option value="BALIKESİR">BALIKESİR </option>
                                    <option value="BARTIN">BARTIN </option>
                                    <option value="BATMAN">BATMAN </option>
                                    <option value="BAYBURT">BAYBURT </option>
                                    <option value="BİLECİK">BİLECİK </option>
                                    <option value="BİNGÖL">BİNGÖL </option>
                                    <option value="BİTLİS">BİTLİS </option>
                                    <option value="BOLU">BOLU </option>
                                    <option value="BURDUR">BURDUR </option>
                                    <option value="BURSA">BURSA </option>
                                    <option value="ÇANAKKALE">ÇANAKKALE </option>
                                    <option value="ÇANKIRI">ÇANKIRI </option>
                                    <option value="ÇORUM">ÇORUM </option>
                                    <option value="DENİZLİ">DENİZLİ </option>
                                    <option value="DİYARBAKIR">DİYARBAKIR </option>
                                    <option value="DÜZCE">DÜZCE </option>
                                    <option value="EDİRNE">EDİRNE </option>
                                    <option value="ELAZIĞ">ELAZIĞ </option>
                                    <option value="ERZİNCAN">ERZİNCAN </option>
                                    <option value="ERZURUM">ERZURUM </option>
                                    <option value="ESKİŞEHİR">ESKİŞEHİR </option>
                                    <option value="GAZİANTEP">GAZİANTEP </option>
                                    <option value="GİRESUN">GİRESUN </option>
                                    <option value="GÜMÜŞHANE">GÜMÜŞHANE </option>
                                    <option value="HAKKARİ">HAKKARİ </option>
                                    <option value="HATAY">HATAY </option>
                                    <option value="IĞDIR">IĞDIR </option>
                                    <option value="ISPARTA">ISPARTA </option>
                                    <option value="İÇEL">İÇEL </option>
                                    <option value="İSTANBUL">İSTANBUL </option>
                                    <option value="İZMİR">İZMİR </option>
                                    <option value="KARABÜK">KARABÜK </option>
                                    <option value="KARAMAN">KARAMAN </option>
                                    <option value="KARS">KARS </option>
                                    <option value="KASTAMONU">KASTAMONU </option>
                                    <option value="KAYSERİ">KAYSERİ </option>
                                    <option value="KIRIKKALE">KIRIKKALE </option>
                                    <option value="KIRKLARELİ">KIRKLARELİ </option>
                                    <option value="KIRŞEHİR">KIRŞEHİR </option>
                                    <option value="KİLİS">KİLİS </option>
                                    <option value="KOCAELİ">KOCAELİ </option>
                                    <option value="KONYA">KONYA </option>
                                    <option value="KÜTAHYA">KÜTAHYA </option>
                                    <option value="MALATYA">MALATYA </option>
                                    <option value="MANİSA">MANİSA </option>
                                    <option value="KAHRAMANMARAŞ">KAHRAMANMARAŞ </option>
                                    <option value="MARDİN">MARDİN </option>
                                    <option value="MUĞLA">MUĞLA </option>
                                    <option value="MUŞ">MUŞ </option>
                                    <option value="NEVŞEHİR">NEVŞEHİR </option>
                                    <option value="NİĞDE">NİĞDE </option>
                                    <option value="ORDU">ORDU </option>
                                    <option value="OSMANİYE">OSMANİYE </option>
                                    <option value="RİZE">RİZE </option>
                                    <option value="SAKARYA">SAKARYA </option>
                                    <option value="SAMSUN">SAMSUN </option>
                                    <option value="SİİRT">SİİRT </option>
                                    <option value="SİNOP">SİNOP </option>
                                    <option value="SİVAS">SİVAS </option>
                                    <option value="ŞIRNAK">ŞIRNAK </option>
                                    <option value="TEKİRDAĞ">TEKİRDAĞ </option>
                                    <option value="TOKAT">TOKAT </option>
                                    <option value="TRABZON">TRABZON </option>
                                    <option value="TUNCELİ">TUNCELİ </option>
                                    <option value="ŞANLIURFA">ŞANLIURFA </option>
                                    <option value="UŞAK">UŞAK </option>
                                    <option value="VAN">VAN </option>
                                    <option value="YALOVA">YALOVA </option>
                                    <option value="YOZGAT">YOZGAT </option>
                                    <option value="ZONGULDAK">ZONGULDAK </option>
                                    <option value="ADANA">ADANA </option>
                        </select>
                        <div v-if="submitted && !$v.user.sehir.required" class="invalid-feedback">Şehir seçiniz</div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-12">
                        <label for="adres">AÇIK ADRES*</label>
                        <textarea class="form-control" v-model="user.adres" id="adres" v-uppercase name="adres" :class="{ 'is-invalid': submitted && $v.user.adres.$error }"></textarea>
                        <div v-if="submitted && !$v.user.adres.required" class="invalid-feedback">Adresinizi giriniz</div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-12" style="margin-bottom: -15px !important;">
                        <md-checkbox v-model="user.telefon_izni" value="1"> </md-checkbox>
                        <span @click="MarketingDialog=true" style="cursor: pointer;">Çağrı Merkezi / Telefon yoluyla bilgilendirme / duyuru yapılmasını kabul ediyorum.</span>
                    </div>
                    <div class="form-group col-md-12" style="margin-bottom: -15px !important;">
                        <md-checkbox v-model="user.email_izni" value="1"> </md-checkbox>
                        <span @click="MarketingDialog=true" style="cursor: pointer;">E-posta yoluyla bilgilendirme / duyuru yapılmasını kabul ediyorum.</span>
                    </div>
                    <div class="form-group col-md-12" style="margin-bottom: -15px !important;">
                        <md-checkbox v-model="user.sms_izni" value="1"> </md-checkbox>
                        <span @click="MarketingDialog=true" style="cursor: pointer;">SMS / MMS / Cep telefonu yoluyla bilgilendirme / duyuru yapılmasını kabul ediyorum.</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="form-row">
                    <div class="form-group col-md-6">
                    </div>
                    <div class="form-group col-md-6">
                        <button type="submit" class="btnRed float-right" style="padding: 2px 18px 0px 18px !important">Güncelle <i class="fas fa-long-arrow-alt-right"></i></button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
</div>
<md-dialog-alert
:md-active.sync="MarketingDialog"
md-title="Pazarlama İzni Metni"
md-content="www.popycar.com internet adresinden kamuoyu ile paylaşılmış olan “Aydınlatma Metni” ve “Kişisel Verilerin Korunması ve İşlenmesi Politikası”nda belirtilen amaçlarla; 6698 sayılı Kişisel Verilerin Korunması Kanunu ve 6563 sayılı Elektronik Ticaretin Düzenlenmesi Hakkında Kanun gereğince gerekli bilgilendirmenin tarafıma yapıldığını kabul ediyorum. İşbu muvafakatname ile 6563 sayılı Elektronik Ticaretin Düzenlenmesi Hakkında Kanun kapsamında gerek her türlü satın alma ve pazarlama işlemleri ve uygulamaları ile akdi-kanuni hususlardan kaynaklanan bilgilendirilmeler yapılması, PopyCar Oto Kiralama A. Ş. tarafından sunulan ürün ve hizmetlerin ve genel / özel imkanların duyurulması, tanıtım ve reklamının yapılması için tarafıma ilgili kanunlara uygun olarak ticari elektronik ileti ve diğer iletiler gönderilmesini, iletişim bilgilerimin bu amaçla alındığını, iletişim bilgilerimin gizliliklerinin korunması için gerekli tedbirlerin alınarak ve işlenmesine dair kanuni ilkelere uygun şekilde yukarıda belirtilenler amaçlarla PopyCar Oto Kiralama A. Ş. iştirak, iş ortağı, araç kiralama şirketinin hizmet aldığı üçüncü kişi firmalar da dahil olmak üzere belirleyecekleri üçüncü kişiler tarafından yasal azami süre aşılmamak üzere öngörülecek süre için yurt içinde ve dışında fiziki-elektronik ortamlarda kaydedilip saklanacağını, kullanılacağını, güncelleneceğini, sınıflandırılacağını, aktarılacağı-paylaşılacağı ve otomatik olan / olmayan yöntemler ile temin olunarak kanunlarda belirtilen diğer suretlerle işleneceğini, her zaman iletişim tercihlerimi değiştirebileceğimi veya hiçbir gerekçe göstermeksizin tarafıma gelen iletileri belirtilen ret seçeneği ile durdurabileceğimi, her türlü ürün ve hizmetlere ilişkin çeşitli bilgilendirme, tanıtım, reklam, promosyon, satış ve pazarlama faaliyetleri kapsamında yapılan anket uygulamaları da dahil olmak üzere PopyCar Oto Kiralama A. Ş. tarafından kanunlara uygun şekilde SMS / kısa mesaj, otomatik arama, telefonla arama, sosyal medya ile online reklam ağları, e-posta / mail ve diğer elektronik iletişim araçları-kanalları yoluyla tarafıma ticari elektronik iletiler ve diğer iletiler gönderilmesini kabul ediyorum."
md-confirm-text="Devam" />
<md-dialog-alert
      :md-active.sync="hataMesajiDurum"
      :md-title="`${hataMesajiBaslik}`"
      :md-content="`${hataMesaji}`" />
</div>
</section>
</template>
<script>
import { required, email } from 'vuelidate/lib/validators'
import axios from 'axios'
import store from '../store'
import {mapState} from 'vuex'
import MenuPanelim from './MenuPanelim'
export default {
  name: 'Panelim',
  metaInfo: () => ({
    title: 'Panelim',
    titleTemplate: '%s - PopyCar',
    htmlAttrs: {
      lang: 'tr',
      amp: true
    },
    meta: [
      { name: 'description', content: 'Panelim' }
    ]
  }),
  components: {
    MenuPanelim,
  },
  data: () => {
    return {
    MarketingDialog: false,
    isLoading: false,
    fullPage: true,
    loader: 'bars',
    color: '#d2202f',
      parolamaGuncelle: false,
      user: {
        ad: '',
        soyad: '',
        dogumTarihi: '',
        kimlik_tipi: '',
        kimlik_no: '',
        ehliyet_no: '',
        ehliyet_alis_yeri: '',
        ehliyet_tarih: '',
        eposta: '',
        gsm: '',
        ulke: '',
        sehir: '',
        adres: '',
        email_izni: false,
        telefon_izni: false,
        sms_izni: false
      },
      submitted: false,
      hataMesajiDurum: false,
        hataMesaji: false,
        hataMesajiBaslik: false
    }
  },
  validations: {
    user: {
      ad: { required },
      soyad: { required },
      dogumTarihi: { required },
      kimlik_tipi: { required },
      kimlik_no: { required },
      ehliyet_no: { required },
      ehliyet_alis_yeri: {required},
      ehliyet_tarih: { required },
      eposta: { required, email },
      gsm: { required },
      ulke: { required },
      sehir: { required },
      adres: { required }
    }
  },
  methods: {
    handleSubmit (e) {
      this.submitted = true
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      let loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        loader: this.loader,
        color: this.color,
        opacity: 0.90,
        /*height: '120px',
        width: '120px',*/
        });
      var params = JSON.stringify(this.user);
      axios.post(process.env.VUE_APP_API_URL+'uyeGuncelle.php', params, {withCredentials: true, headers: {
    'Cache-Control': 'no-cache',
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    'Access-Control-Allow-Origin': '*'
  }}).then(response => {
        if (response.data.basarili==1){
            this.hataMesajiDurum=true
            this.hataMesaji=response.data.mesaj
            this.hataMesajiBaslik=response.data.baslik
            loader.hide()
        } else {
            this.hataMesajiDurum=true
            this.hataMesaji=response.data.mesaj
            this.hataMesajiBaslik=response.data.baslik
            loader.hide()
        }
      })
    }
  },
  computed: mapState({
        GetServer: state => state.GetServerData,
  }),
  created: function() {
      this.user.ad = this.$store.state.GetServerData.member.Name,
      this.user.soyad=this.$store.state.GetServerData.member && this.$store.state.GetServerData.member.Surname,
      this.user.dogumTarihi=this.$store.state.GetServerData.member && this.$store.state.GetServerData.member.Birthday,
      this.user.kimlik_tipi=this.$store.state.GetServerData.member && this.$store.state.GetServerData.member.choose_identity,
      this.user.kimlik_no=this.$store.state.GetServerData.member && this.$store.state.GetServerData.member.IdentityNumber,
      this.user.ehliyet_no=this.$store.state.GetServerData.member && this.$store.state.GetServerData.member.DriversLicenseNumber,
      this.user.ehliyet_alis_yeri=this.$store.state.GetServerData.member && this.$store.state.GetServerData.member.DriversLicensePlace,
      this.user.ehliyet_tarih=this.$store.state.GetServerData.member && this.$store.state.GetServerData.member.DriversLicenseDate,
      this.user.eposta=this.$store.state.GetServerData.member && this.$store.state.GetServerData.member.Mail,
      this.user.gsm=this.$store.state.GetServerData.member && this.$store.state.GetServerData.member.Phone,
      this.user.ulke=this.$store.state.GetServerData.member && this.$store.state.GetServerData.member.Country,
      this.user.sehir=this.$store.state.GetServerData.member && this.$store.state.GetServerData.member.City,
      this.user.adres=this.$store.state.GetServerData.member && this.$store.state.GetServerData.member.Adress,

      this.user.sms_izni=this.$store.state.GetServerData.member && this.$store.state.GetServerData.member.sms_izni,
      this.user.telefon_izni=this.$store.state.GetServerData.member && this.$store.state.GetServerData.member.telefon_izni,
      this.user.email_izni=this.$store.state.GetServerData.member && this.$store.state.GetServerData.member.email_izni
  }
}
</script>

<style>
.vti__dropdown:hover{
    background-color: #ededed !important;
}
.vti__dropdown{
    background-color: #ededed !important;
}
</style>
